<template>
  <div>
    <PSecondaryButton appkit-icon="icon-download-outline" @click="open"
      >Export</PSecondaryButton
    >
    <ExportSupplierDialog
      :open-dialog="isDialogOpen"
      @close-dialog="close"
      @suppliers-uploaded="onSuppliersUploaded"
    />
  </div>
</template>

<script setup lang="ts">
import PIconButton from "@/components/custom/buttons/PIconButton.vue";
import { ref } from "vue";
import ExportSupplierDialog from "@/views/supplier-registry/ExportSupplierDialog.vue";
import PSecondaryButton from "@/components/custom/buttons/PSecondaryButton.vue";

const emits = defineEmits<{
  (e: "suppliersUploaded"): void;
}>();

const isDialogOpen = ref(false);

const open = () => (isDialogOpen.value = true);
const close = () => (isDialogOpen.value = false);

function onSuppliersUploaded(): void {
  emits("suppliersUploaded");
  close();
}
</script>
